import React from 'react';

// OpenEyeIcon component - you can also import this if it's in a separate file
const OpenEyeIcon = () => (
  <svg
    width="135.424"
    height="131.269"
    viewBox="30 100 150 150"
    xmlns="http://www.w3.org/2000/svg"
    className="w-32 h-32 md:w-48 md:h-48 lg:w-64 lg:h-64" // Responsive sizing
  >
    <path
      fill="#030303"
      d="M111.151 171.051c-1.14-0.025-2.275 0.029-3.38 0.179-4.229 0.576-8.372 1.94-11.906 4.396-17.85 12.401-12.887 40.642 7.938 46.478 3.02 0.846 6.4 1.17 9.525 0.796 4.108-0.491 8.179-1.769 11.642-4.092 18.217-12.22 13.881-42.108-8.202-47.05-1.804-0.404-3.717-0.666-5.617-0.708zM110.418 181.634c14.688-0.068 21.889 20.707 8.099 28.694-1.807 1.046-3.747 1.738-5.821 2.007-2.266 0.294-4.695 0.085-6.88-0.569-15.236-4.564-13.204-27.74 2.381-29.967 0.757-0.108 1.497-0.162 2.22-0.165z"
    />
    <path
      fill="#030303"
      d="M111.077 150.371c-1.335 0.002-2.654 0.077-3.937 0.245-5.219 0.685-10.264 1.193-15.346 2.724-14.992 4.515-28.202 14.081-38.209 26.004-2.993 3.566-5.656 7.379-8.04 11.377-1.07 1.792-2.553 3.942-2.671 6.085-0.123 2.243 1.416 4.497 2.513 6.35 2.789 4.714 5.995 9.074 9.558 13.23 15.752 18.369 40.003 29.93 64.366 26.648 19.456-2.621 37.078-14.475 49.212-29.558 2.762-3.434 5.27-7.055 7.514-10.848 0.982-1.659 2.255-3.559 2.255-5.556 0-2.237-1.572-4.496-2.678-6.35-2.617-4.388-5.574-8.562-8.908-12.435-11.29-13.118-26.611-23.096-43.691-26.512-3.779-0.756-7.933-1.408-11.938-1.403zm1.076 10.503c17.032 0.146 34.106 10.271 44.881 22.697 2.642 3.047 5.19 6.168 7.433 9.525 0.707 1.059 2.205 2.631 2.205 3.969 0 1.263-1.363 2.706-2.029 3.704-2.039 3.057-4.303 5.95-6.703 8.731-10.487 12.157-24.886 21.253-41.01 23.208-19.602 2.376-37.52-6.688-51.064-20.297-3.34-3.356-6.361-7.18-8.996-11.113-0.749-1.117-2.382-2.823-2.382-4.233 0-1.263 1.363-2.706 2.029-3.704 2.1-3.149 4.426-6.155 6.926-8.996 11.547-13.118 26.128-21.166 43.432-23.207 1.754-0.207 3.516-0.299 5.278-0.284z"
    />
    <path
      fill="#030303"
      d="M166.672 139.181c-1.772 0.465-3.197 2.073-4.498 3.27-3.157 2.903-8.632 6.148-10.474 10.077-1.855 3.957 1.687 8.422 5.976 7.396 1.872-0.448 3.11-1.864 4.498-3.087 3.257-2.867 8.96-6.416 10.798-10.394 1.92-4.155-1.976-8.395-6.299-7.261z"
    />
    <path
      fill="#030303"
      d="M50.981 139.955c-3.305 0.955-4.533 4.936-2.851 7.769 0.936 1.576 2.578 2.721 3.91 3.946 3.361 3.091 8.864 10.453 14.023 8.881 3.266-0.995 4.481-4.97 2.783-7.799-1.024-1.706-2.894-3.01-4.37-4.31-3.373-2.969-8.344-9.976-13.494-8.487z"
    />
    <path
      fill="#030303"
      d="M142.794 119.821c-2.12 0.193-3.646 1.43-4.555 3.299-2.104 4.328-3.952 8.818-5.876 13.23-0.877 2.01-2.242 4.133-2.484 6.35-0.348 3.191 2.308 5.971 5.506 5.792 2.346-0.131 3.838-1.7 4.826-3.676 1.941-3.877 3.527-7.953 5.309-11.906 0.958-2.125 2.49-4.546 2.781-6.88 0.419-3.359-1.875-6.54-5.507-6.21z"
    />
    <path
      fill="#030303"
      d="M78.353,119.599 c -3.304,0.3 -5.107,3.058 -4.714,6.21 0.303,2.427 1.918,4.926 2.898,7.144 1.864,4.215 3.385,9.091 5.908,12.954 1.034,1.583 3.011,2.549 4.903,2.342 2.882,-0.315 5.031,-2.849 4.713,-5.771 -0.302,-2.77 -2.175,-5.688 -3.309,-8.202 -1.787,-3.965 -3.188,-8.483 -5.496,-12.17 -1.207771,-1.94473 -2.875502,-2.69356 -4.903,-2.507z"
    />
    <path
      fill="#030303"
      d="M109.586 112.433c-2.236 0.481-3.768 2.108-4.147 4.361-0.789 4.687-0.086 10.062-0.086 14.817 0 2.641-0.517 5.915 0.209 8.467 0.717 2.522 3.21 4.337 5.877 3.882 2.176-0.372 3.864-2.005 4.358-4.146 1.076-4.662 0.14-10.559 0.14-15.346 0-2.558 0.501-5.732-0.209-8.202-0.761-2.646-3.384-4.425-6.141-3.832z"
    />
  </svg>
);

const OpenEye = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <div className="max-w-4xl mx-auto text-center">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-800 mb-4">
            Open Eye
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            Vision and insight through clarity and focus
          </p>
        </div>

        {/* Main Open Eye Icon */}
        <div className="mb-8 flex justify-center">
          <div className="p-8 bg-white rounded-full shadow-lg hover:shadow-xl transition-shadow duration-300">
            <OpenEyeIcon />
          </div>
        </div>
        {/* Footer */}
        <div className="mt-12 text-gray-500 text-sm">
          <p>Open Eye - Seeing beyond the ordinary</p>
        </div>
      </div>
    </div>
  );
};

export default OpenEye;